export var GQLExtensionContextsFilterType = /*#__PURE__*/function (GQLExtensionContextsFilterType) {
  GQLExtensionContextsFilterType["Container"] = "CONTAINER";
  GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
  GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
  GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
  GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
  return GQLExtensionContextsFilterType;
}({});
export var isGQLGatewayError = function isGQLGatewayError(err) {
  return err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
};
export var isGQLUnderlyingServiceError = function isGQLUnderlyingServiceError(err) {
  return err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
};